! function(module) {
    //>>excludeStart("requireTmpl", pragmas.requireTmpl);
    if (typeof window['define'] === 'function' && window['define']['amd']) define('hotels/filterUtils',['hotels/hotel_utils'], module) //Add 'Routes' dependencies here
    else
    //>>excludeEnd("requireTmpl");
        module()
}(function() {
    /**
     * helper functions, locality modal window functions and locality auto suggest functions.
     ***************************************************************************************/
    CT.utils.findAreaLatLng = function(area, isOp) { // finds latlng for particular area.
        if (CT.isLocationEnabled == true) {
            var area_info = {};
            var city = CT.masterJson.get().json ? CT.masterJson.get().json.city : CT.masterJson.get().city;
            _.each(CT.masterJson.get().ar[city], function(val) {
                if (area.replace && area.replace(/\s/g, '') == (val.nm ||  val.name || '').replace(/\s/g, '')) {
                    area_info.latlng = val["latlng"] ? val["latlng"] : CT.cache[CT.settings.currentTab].googleSortedAreaLatLng ? CT.cache[CT.settings.currentTab].googleSortedAreaLatLng : '';
                    area_info.localityId = val['id'] ? val['id'] : '';
                }
            });
            if (($.isEmptyObject(area_info) || !area_info.latlng || area_info.localityId) && CT.masterJson.get().tl) {
                _.each(CT.masterJson.get().tl, function(item, index) {
                    if (item.localityName == area) {
                        area_info.latlng = [parseFloat(item.latitude), parseFloat(item.longitude)];
                        area_info.localityId = item.localityId;
                    }
                });
            }
            return area_info;
        } else {
            var area_latlng = "";
            _.each(CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data, function(val) {
                //TODO:: Locality Filter :: Replace with commented line
                if (area.replace(/\s/g, '') == (val.loc && val.loc.replace(/\s/g, ''))) {
                // if (area.replace(/\s/g, '') == val.nm.replace(/\s/g, '')) {
                    area_latlng = val["latlng"];
                }
            });
            if (area_latlng == "" && CT.masterJson.get().tl) {
                _.each(CT.masterJson.get().tl, function(item, index) {
                    if (item.localityName == area) {
                        area_latlng = [parseFloat(item.latitude), parseFloat(item.longitude)];
                    }
                });
            }
            return area_latlng;
        }
    };

    CT.utils.findPOILatlng = function(poi) { // finds latlng for particular poi.
        if (CT.isLocationEnabled == true) {
            var poi_info = {};
            var city = CT.masterJson.get().json ? CT.masterJson.get().json.city : CT.masterJson.get().city;
            _.each(CT.masterJson.get().poi[city], function(val) {
                if (poi.replace(/\s/g, '') == (val.nm ||  val.name || '').replace(/\s/g, '')) {
                    poi_info.latlng = val["lat"] && val["lng"] ? [parseFloat(val["lat"]), parseFloat(val["lng"])] : '';
                    poi_info.localityId = val['id'] ? val['id'] : '';
                }
            });
            if (($.isEmptyObject(poi_info) || !poi_info.latlng || poi_info.localityId) && CT.masterJson.get().tl) {
                _.each(CT.masterJson.get().tl, function(item, index) {
                    if (item.localityName == poi) {
                        poi_info.latlng = [parseFloat(item.latitude), parseFloat(item.longitude)];
                        poi_info.localityId = item.localityId;
                    }
                });
            }
            return poi_info;
        } else {
            var poi_latlng = "";
            var city = CT.masterJson.get().json ? CT.masterJson.get().json.city : CT.masterJson.get().city;
            _.each(CT.masterJson.get().poi, function(poiArr, city) {
                _.each(CT.masterJson.get().poi[city], function(val) {
                    if (poi == val.nm) {
                        poi_latlng = [val.lat, val.lng];
                    }
                });
            });
            if (poi_latlng == "" && CT.masterJson.get().tl) {
                _.each(CT.masterJson.get().tl, function(item, index) {
                    if (item.localityName == poi) {
                        poi_latlng = [parseFloat(item.latitude), parseFloat(item.longitude)];
                    }
                });
            }
            return poi_latlng;
        }
    };
    CT.utils.checkOpaqueHotels = function(ar) {
        var city = CT.masterJson.get().city;
        var locId;
        _.each(CT.masterJson.get().ar[city], function(area) {
            if (ar.replace(/\s/g, '') == area.nm.replace(/\s/g, '')) {
                locId = area.id ? area.id : '';
            }
        })
        return locId
    };
    //Utility method to get top Poi
    CT.utils.getTopPoi = function() {
        var pois = CT.masterJson.get().poi;
        if (!$.isEmptyObject(pois)) {
            var cityId = CT.masterJson.get().json ? CT.masterJson.get().json.city : CT.masterJson.get().city;
            var poiList = pois[cityId];
            if(poiList){
            	for (var i = 0; i < poiList.length; i++) {
                    if (poiList[i].lat && poiList[i].lng && poiList[i].lat != "" && poiList[i].lng != "")
                        return poiList[i];
                }
            }
            
        }
        return "";
    };
    CT.utils.toRad = function(deg) { // convert degrees to radians
        return deg * Math.PI / 180;
    };

    CT.utils.findDistance = function(d1, d2) { //finds distance between 2 points
        var lat1 = d1[0],
            lon1 = d1[1],
            lat2 = d2[0],
            lon2 = d2[1];

        var R = 6371;
        // Radius of the earth in km
        var dLat = CT.utils.toRad((lat2 - lat1));
        // Javascript functions in radians
        var dLon = CT.utils.toRad((lon2 - lon1));
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(CT.utils.toRad(lat1)) * Math.cos(CT.utils.toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c;
        // Distance in km
        return d;
    };

    //auto suggest handler[filters & right side top search bar] for results page

    CT.utils.searchAreaPoi = {
        //this variable has been moved to tab cache - karthik
        //TODO:: Locality Filter :: Comment Below Line Start
        prevAddedLoc : [],

        /**
         * finds the area hotel cnt
         * @val = Area value eg: HBR Layout
         */
        findAreaHotelCnt: function(val) {
            //some times area cnt wont be avaliable in CT.cache[CT.settings.currentTab].filterValues.areasLatlng
            try {
                var areaFound = _.find(CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data, function(num) {
                    return num.loc == val;
                });
                var areacnt = 0;

                if (areaFound) {
                    areacnt = areaFound.cnt;
                }
                if (areacnt > 0)
                    return areacnt
                else
                    return 0;
            } catch (e) {
                return 0;
            }

        },

        /**
         * finds the POI hotel cnt
         * @val = POI value eg: Manyata Tech Park
         */
        findPOIHotelCnt: function(val) {
            var cnt = 0;
            $.each(CT.masterJson.get().poi, function(index, poiCity) {
                _.forEach(CT.masterJson.get().poi[index], function(_p) {
                    if (_p.nm == val) {
                        cnt = _p.ht;
                    }
                });
            });
            return cnt;
        },

        /**
         * returns the area or poi check box html based on type
         *
         * @val = area or POI name
         * @type = a or p [area or POI]
         * @cnt = hotels count
         * @chkStatus = check or dontcheck
         *
         * @todo - change to mustache template.
         *
         */
        createChkBox: function(val, type, cnt, chkStatus, isNewCheckbox) {
            var hashModifiers = ['starFilter', 'amenity', 'propertyType', 'area', 'poi'];
            var LocAreaVals = _.deserialize($('#ResultContainer_' + CT.settings.currentTab).find('form.filtersForm').serialize(), hashModifiers);

            var val1 = val.replace(/\s+/g, '_');
            var ty = type === 'poi' ? 'poi' : 'area';
            var data_flt = "area";
            if (type == "chain") {
                ty = "chain";
                data_flt = "chain";
            }
            var s = '';
            if(isNewCheckbox){
                 s = '<label class="control control--checkbox ' + val1 + '" for="' + CT.settings.currentTab + val1 + '">';
                 if (chkStatus == 'check' || _.indexOf(LocAreaVals.area, val) >= 0 || _.indexOf(LocAreaVals.poi, val) >= 0){
                    s += '<input checked type="checkbox" id="' + CT.settings.currentTab + val1 + '" value="' + val + '" data-flt="' + data_flt + '" data-count="' + cnt + '" name="' + ty + '">';
                 } else {
                    s += '<input type="checkbox" id="' + CT.settings.currentTab + val1 + '" value="' + val + '" data-flt="' + data_flt + '" data-count="' + cnt + '" name="' + ty + '">';
                 }
                
                s += '<div class="control__indicator"></div><span class="control__label truncate">'+ val +'';
                s += '(<span class="' + val + '">' + cnt + '</span>)</span></label>';
            } else {
                s = '<li class="' + val1 + '"><label for="' + CT.settings.currentTab + val1 + '">';
                s += '<small class="fRight"> ' + cnt + ' </small>';
                if (chkStatus == 'check' || _.indexOf(LocAreaVals.area, val) >= 0 || _.indexOf(LocAreaVals.poi, val) >= 0)
                    s += '<input checked type="checkbox" id="' + CT.settings.currentTab + val1 + '" value="' + val + '" data-flt="' + data_flt + '" data-count="' + cnt + '" name="' + ty + '">';
                else
                    s += '<input type="checkbox" id="' + CT.settings.currentTab + val1 + '" value="' + val + '" data-flt="' + data_flt + '" data-count="' + cnt + '" name="' + ty + '">';
                s += '<span class="span span18 truncate"> ' + val + '</span>';
                s += '</label></li>';
            }
            
            return s;
        },
        /* Render HTML for Chunky filters
         * by Vijay krisha PRM-16493
         * Todo-Make it Common
         */
        createChunkyHtml: function(val, type, cnt, chkStatus) {
            var tabId = CT.settings.currentTab;
            var li = '<li>';
            li += '<input type="checkbox" checked id="' + tabId + "" + val + '" value="' + val + '" smartFilter="1" name="' + type + '" >';
            li += '<label for="' + tabId + val + '"><span class="span span18 truncate" >' + val + '</span><span class="fRight weak truncate" >' + cnt + '</span></label></li>';
            return li;
        },
        /**
         * after selecting from drop down.
         *
         * location drop down.
         */
        addToLocalities: function(e, ui, triggerFilter) {
            var val, type;
            if (ui.item) {
                val = ui.item.n;
                type = ui.item.ty;
            } else {
                val = ui.nm;
                type = 'a';
            }

            var valModified = val.replace(/\s+/g, '_');
            var tabCache = CT.cache[CT.settings.currentTab];
            var $eventTag;
            var cnt = "";

            if (e)
                $eventTag = $(e.target);

            CT.masterJson.get().clusterMapItems = undefined;
            tabCache.filterClicked = true
            tabCache.mapDragged = false;

            //CT.fire('mapplotlocality', [ui]);
            if (type == 'h') {
                //				_.filter($("#ResultContainer_" + CT.settings.currentTab).find('.listView li.listItem'), function(eachLi) {
                //					if ($(eachLi).find(".summary .info h2").text().toLowerCase().indexOf(val.toLowerCase()) >= 0) {
                //						$(eachLi).css("display", 'block');
                //					} else
                //						$(eachLi).css("display", 'none');
                //				});

                CT.fire('hotelKeywordSearch.init', [val.toLowerCase()]);
            } else {
                //e.target.value = '';
                if (e)
                    $eventTag.attr('data-checkboxid', valModified);

                $("#ResultContainer_" + CT.settings.currentTab).find('.filtersForm input[name="hotelName"]').val('');

                if (type == 'a')
                    cnt = CT.utils.searchAreaPoi.findAreaHotelCnt(val);
                else
                    cnt = CT.utils.searchAreaPoi.findPOIHotelCnt(val);

                //if type is poi or area then reset the current locality filters

                if (type == 'a' || type == 'p')
                    $("#ResultContainer_" + CT.settings.currentTab).find('.filtersForm .locality input:checked').removeAttr('checked');

                if (_.indexOf(tabCache.prevAddedLoc, val) >= 0) {
                    $("#ResultContainer_" + CT.settings.currentTab).find('.filtersForm .locality input[value="' + val + '"]').attr('checked', 'checked');
                    if (!(triggerFilter && triggerFilter.indexOf('dontTriggerFilter') >= 0))
                        $("#ResultContainer_" + CT.settings.currentTab).find('.filtersForm .locality input[value="' + val + '"]').trigger('click').attr('checked', 'checked');
                } else {
                    tabCache.prevAddedLoc.push(val);
                    var _html = CT.utils.searchAreaPoi.createChkBox(val, type == 'a' ? 'area' : 'poi', cnt, "check");
                    $("#ResultContainer_" + CT.settings.currentTab).find('.locality ul').append(_html);
                    if (!(triggerFilter && triggerFilter.indexOf('dontTriggerFilter') >= 0))
                        $("#ResultContainer_" + CT.settings.currentTab).find('.filtersForm .locality input[value="' + val + '"]').trigger('click').attr('checked', 'checked');
                }
            }
            /*
			if (CT.utils.hideModalDialog)
				CT.utils.hideModalDialog();
			*/

        }
    };
    //auto suggest handler - end

    //show all locations modal window [mw]
    CT.utils.mw = {

        /**
         * it will create checkbox's in modal window.
         */
        createHtml: function(list) {
            //var _html = [];
            var localitiesList = [],
                html = '';
            //Hotel Chains
            if (list) {
                _.forEach(list, function(_ch) {
                    localitiesList.push({
                        name: _ch.name,
                        type: "chain",
                        count: _ch.count,
                        checked: "dontcheck"
                    })
                });
                _.forEach(localitiesList, function(locality) {
                    html += CT.utils.searchAreaPoi.createChkBox(locality.name, locality.type, locality.count, locality.checked);
                });
                return html;
            }
            //areas
            _.forEach(CT.cache[CT.settings.currentTab].filterValues.areasLatlng.data, function(_ar) {
                if (_ar.cnt && _ar.cnt > 0)
                    localitiesList.push({
                        name: _ar.loc,
                        type: "area",
                        count: _ar.cnt,
                        checked: "dontCheck"
                    });
                //_html.push(CT.utils.searchAreaPoi.createChkBox(_ar.nm, "area", _ar.ht, "dontCheck"));
            });

            //pois
            $.each(CT.masterJson.get().poi, function(index, poiCity) {
                _.forEach(CT.masterJson.get().poi[index], function(_ar) {
                    if (_ar.ht > 0 && _.indexOf(CT.settings[CT.app].filters.constants.poiShowData, _ar.cat1) >= 0)
                        localitiesList.push({
                            name: _ar.nm,
                            type: "poi",
                            count: _ar.ht,
                            checked: "dontCheck"
                        });
                    //_html.push(CT.utils.searchAreaPoi.createChkBox(_ar.nm, "poi", _ar.ht, "dontCheck"));
                });
            });

            localitiesList = _.sortBy(localitiesList, function(locality) {
                return locality.name;
            });

            _.forEach(localitiesList, function(locality) {
                html += CT.utils.searchAreaPoi.createChkBox(locality.name, locality.type, locality.count, locality.checked);
            });

            return html;
        },

        /**
         * Create destinations checkbox for weekend gateway
         */
        createHtmlForGateways: function() {
            var destList = [],
                html, obj = {},
                alreadyChecked;

            /*	alreadyChecked = _.filter($('.destinations input'),function(ele){ 
				if(ele.checked)
				return ele.value
		})*/
            $.each(CT.masterJson.get().wd.d, function(index, dest) {
                destList.push({
                    name: dest.n,
                    value: dest.i,
                    cnt: dest.cnt
                });
            });
            destList = _.sortBy(destList, function(destination) {
                return destination.name;
            });

            for (var k in alreadyChecked) {
                var tmp = _.findIndex(destList, {
                    'value': alreadyChecked[k]
                });
            }
            obj.destList = destList
            html = CT.to_html('ModalWinCheckBoxTpl', obj);
            return html;
        },
        addlocationsForgateways: function(obj) {
            var _html = [];
            var $currentResultView = $("#ResultContainer_" + CT.settings.currentTab)
            var tabCache = CT.cache[CT.settings.currentTab];


            //$currentResultView.find('.destinations input').removeAttr('checked');
            _.forEach(obj.destList || obj, function(obj1) {
                var cnt = '',
                    isDestShown, html;

                isDestShown = _.filter($('.destinations input'), function(ele) {
                    return ele.value == obj1.value
                })
                if (isDestShown.length >= 1) {
                    $currentResultView.find('.filtersForm .destinations input[value="' + (obj1.value || obj1.nm) + '"]').attr('checked', 'checked');
                } else {
                    html = CT.to_html('ModalWinCheckBoxTpl', obj);
                    $currentResultView.find('.destinations ul').append(html);
                }
            })
            $currentResultView.find('.filtersForm .destinations input[value="' + (obj.destList[0].value) + '"]').trigger('click').attr('checked', 'checked');
        },
        /**
         * creates checkbox's in lhs filter after selecting from modal window.
         */
        addlocations: function(obj, triggerFilter) {
            var _html = [];
            var $currentResultView = $("#ResultContainer_" + CT.settings.currentTab)
            var tabCache = CT.cache[CT.settings.currentTab];
            var filterType = obj.type,
                filterCls = obj.class;
            triggerFilter = triggerFilter || '';

            if (!(triggerFilter.indexOf('dontTriggerFilter') >= 0))
                CT.utils.showLoader('hotel');


            $currentResultView.find(filterCls + " input").removeAttr('checked');
            _.forEach(obj.data || obj, function(obj1) {
                var cnt = '';

                if (tabCache["prevAdded" + filterType].indexOf(obj1.value || obj1.nm) >= 0) {
                    $currentResultView.find('.filtersForm ' + filterCls + ' input[value="' + (obj1.value || obj1.nm) + '"]').attr('checked', 'checked');
                } else {
                    tabCache["prevAdded" + filterType].push(obj1.value || obj1.nm);
                    /*
					if (obj1.ty == 'area')
						cnt = CT.utils.searchAreaPoi.findAreaHotelCnt(obj1.value);
					else
						cnt = CT.utils.searchAreaPoi.findPOIHotelCnt(obj1.value);
					*/
                    if (filterType == "chains") {
                        var htmlMarkup = CT.utils.searchAreaPoi.createChunkyHtml(obj1.value, obj1.ty, obj1.count, "check");
                        _html.push(htmlMarkup);
                    } else
                        _html.push(CT.utils.searchAreaPoi.createChkBox((obj1.value || obj1.nm), (obj1.ty ? (obj1.ty === 'area' ? 'area' : 'poi') : 'area'), (obj1.count || obj1.ht), "check", true));
                }
            });
            if (!(triggerFilter.indexOf('dontTriggerFilter') >= 0)) {
                // Patch to resolve location filter, please remove this piece of code after change.
                $currentResultView.find("nav" + filterCls).find('label:last').after(_html.join(" "));
                $currentResultView.find("nav" + filterCls).find('input[value="' + obj.data[(obj.data.length - 1)].value + '"]').trigger('click').attr('checked', 'checked');
            } else {
                $currentResultView.find(filterCls + ' ul').append(_html.join(" "))
            }
        }
    };

    CT.utils.createEmailHotels = {
        createHotelMarkup: function() {
            var obj = [],
                k = 0;
            var listUnits = _.first($("#ResultContainer_" + CT.settings.currentTab).find(".hotelsList .listItem"), 10)
            for (var i = 0; i < listUnits.length; i++) {
                var hotelObj = CT.masterJson.getHotel($(listUnits[i]).attr("id"));
                var pr = hotelObj.priceInfo ? hotelObj.priceInfo.rms[0].avg : 0;
                if (pr != 0 && k < 5) {
                    obj.push({
                        "nm": hotelObj.nm,
                        "sr": hotelObj.sr,
                        "ar": hotelObj.ar,
                        "pr": CT.utils.formatForCurrency(pr)
                    });
                    k++;
                }
            }
            /*_.each(CT.masterJson.get().ht,function (i,j){
				var pr = i.priceInfo ? i.priceInfo.rms[0].avg : 0;
				if(pr != 0 && k < 5){
					obj.push({"nm":i.nm, "sr":i.sr, "ar": i.ar,"pr":CT.utils.formatForCurrency(pr)});
					k++;
				}
			})*/

            var html = CT.to_html('ModalEmailHotelsTpl', {
                "data": obj
            });
            return html;
        }
    }
});
